import React from "react";
import type { ButtonVariant } from "@/shared/ui/Button";
import { IconButton } from "@/shared/ui/IconButton";
import { IconName } from "@/shared/ui/Icon";
import { FeatureGate } from "@/shared/widgets/FeatureFlags";
import { FeatureFlagKey } from "@/types/feature-flags";
import { PowerpointGenerator } from "@/lib/ppt-generator/powerpointGenerator";
import { useTranslation } from "react-i18next";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui";

interface PPTGeneratorButtonProps {
  templateName: string;
  data: any;
  fileName: string;
  icon?: string;
  color?: string;
  label?: string;
  variant?: "outline" | "solid" | "ghost";
  disabled?: boolean;
  tooltip?: string;
}

export const PPTGeneratorButton: React.FC<PPTGeneratorButtonProps> = ({
  templateName,
  data,
  fileName,
  icon = "File",
  color = "black",
  label,
  variant = "outline",
  disabled = false,
  tooltip = "",
}) => {
  const { t } = useTranslation();

  const handleGeneratePPT = async () => {
    try {
      const generator = new PowerpointGenerator();

      await generator.generatePresentation({
        templateName,
        data,
        fileName,
      });

      console.log(
        t(
          "pptGenerator.presentationGenerationStarted",
          "Presentation generation started (download should begin)."
        )
      );
    } catch (error) {
      console.error(
        t(
          "pptGenerator.errorGeneratingPresentation",
          "Error generating PowerPoint presentation:"
        ),
        error
      );
    }
  };

  return (
    <FeatureGate flagKey={FeatureFlagKey.PPT_EXPORT_RRA}>
      <Tooltip>
        <TooltipTrigger asChild>
          <IconButton
            icon={icon as IconName}
            color={color}
            label={label || t("pptGenerator.generatePPT", "Generate PPT")}
            variant={variant as ButtonVariant}
            onClick={handleGeneratePPT}
            disabled={disabled}
          />
        </TooltipTrigger>
        {disabled && !!tooltip && <TooltipContent>{tooltip}</TooltipContent>}
      </Tooltip>
    </FeatureGate>
  );
};
